"use client";

import Script from 'next/script';
import { Suspense, useEffect } from 'react';
import { GA_MEASUREMENT_ID, trackSessionStart, trackPageView } from '@/lib/analytics';
import { usePathname, useSearchParams } from 'next/navigation';

// Component that uses useSearchParams - must be wrapped in Suspense
function AnalyticsTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Track page views on route change
  useEffect(() => {
    if (pathname) {
      trackPageView(pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : ''));
    }
  }, [pathname, searchParams]);

  // Track session start on mount
  useEffect(() => {
    trackSessionStart();
  }, []);

  return null;
}

export default function Analytics() {
  // Don't load in development to save quota
  if (process.env.NODE_ENV === 'development') {
    return null;
  }

  // Don't load if no GA ID
  if (!GA_MEASUREMENT_ID) {
    return null;
  }

  return (
    <>
      <Suspense fallback={null}>
        <AnalyticsTracker />
      </Suspense>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  );
}

